import React from 'react';
import ModuleBase from '../../components/ModuleBase/ModuleBase';
import styles from './style.module.scss';

const HotspotImage = ({ data, onEdit }) => {
    const { image, hotspots = [], imageStyle = {}, style = {} } = data || {};

    const handleHotspotClick = (link) => {
        if (link) {
            window.location.href = link;
        }
    };

    // 将rpx转换为px，基于图片实际宽度
    const rpxToPx = (rpx, imgWidth) => {
        // 确保rpx是数字
        const rpxValue = Number(rpx) || 0;
        const result = (rpxValue * imgWidth) / 750;
        console.log(`rpxToPx: ${rpx}(${typeof rpx}) => ${result}px, imgWidth=${imgWidth}`);
        return result;
    };

    // 获取图片元素的引用，用于获取实际宽度
    const imgRef = React.useRef(null);
    const [imgWidth, setImgWidth] = React.useState(0);

    React.useEffect(() => {
        const updateImgWidth = () => {
            if (imgRef.current) {
                const newWidth = imgRef.current.offsetWidth;
                console.log(`图片宽度更新: ${imgWidth} => ${newWidth}`);
                setImgWidth(newWidth);
            }
        };

        // 初始加载和窗口大小变化时更新宽度
        updateImgWidth();
        window.addEventListener('resize', updateImgWidth);

        // 图片加载完成后更新宽度
        if (imgRef.current) {
            imgRef.current.onload = updateImgWidth;
        }

        return () => {
            window.removeEventListener('resize', updateImgWidth);
        };
    }, [image]);

    return (
        <ModuleBase onEdit={onEdit} style={style}>
            <div className={styles.hotspotImage}>
                {image ? (
                    <>
                        <img
                            ref={imgRef}
                            src={image}
                            alt=""
                            style={{
                                ...imageStyle
                            }}
                        />
                        {console.log('渲染热区数据:', hotspots, '图片宽度:', imgWidth)}
                        {hotspots.map((hotspot, index) => {
                            console.log(`渲染热区 ${index}:`, hotspot);
                            return (
                                <div
                                    key={index}
                                    className={styles.hotspot}
                                    style={{
                                        left: `${rpxToPx(hotspot.x, imgWidth)}px`,
                                        top: `${rpxToPx(hotspot.y, imgWidth)}px`,
                                        width: `${rpxToPx(hotspot.w, imgWidth)}px`,
                                        height: `${rpxToPx(hotspot.h, imgWidth)}px`,
                                    }}
                                    onClick={() => handleHotspotClick(hotspot.l)}
                                />
                            );
                        })}
                    </>
                ) : (
                    <div className={styles.placeholder}>
                        请上传图片
                    </div>
                )}
            </div>
        </ModuleBase>
    );
};

export default HotspotImage;